import { commonActions, apiActions } from '../app/actions';
import { makeRequest } from '../lib/fetch';
import { fireMessageEvent } from '../messenger/utils';

const getLeaderBoardRoute = {
  season: 'seasonLeaderboard',
  monthly: 'leaderboard',
  playoffs: 'postSeasonLeaderboard',
};

// TODO: REMOVE WHEN BOOM GOES LIVE
// The following is for mocking responses in dev/staging only, refer to boom doc: 'CLIENT: Tim Hortons API Manual'
// const getMockResponse = (board) => {
//   switch (board) {
//     case 'season':
//       return 'closed-season';
//     case 'monthly':
//       return 'closed-challenge';
//     case 'playoffs':
//       return 'current-postseason';
//     default:
//       return 'current-challenge';
//   }
// };

const fetchContestRank = ({
  dispatch,
  apiUrl,
  userId,
  env,
  currentSession,
  board = null,
  isLocal = false,
  challengeNumber,
  season,
  platform,
  // mockresponse,
}) => {
  const actionType = isLocal ? 'local_leaderboard' : 'leaderboard';
  const { fetchSuccess, fetchFailure } = apiActions(actionType);
  const { fetchFailure: authFailure } = apiActions('auth');
  const suffix = isLocal ? 'Local' : '';
  return makeRequest({
    method: 'GET',
    apiUrl,
    userId,
    env,
    currentSession,
    route: `${getLeaderBoardRoute[board]}${suffix}`,
    // TODO: REMOVE WHEN BOOM GOES LIVE
    // ...(env === 'staging' && { headers: { mockresponse } }),
    ...(challengeNumber && { params: { challengeNumber, season } }),
  }).then(
    (resp) => {
      return dispatch(fetchSuccess({ ...resp, board }));
    },
    (err) => {
      if (err.status === 401) {
        return dispatch(authFailure());
      }
      const messageData = {
        err,
        apiUrl,
        route: `${getLeaderBoardRoute[board]}${suffix}`,
        userId,
        currentSession,
      };
      fireMessageEvent({
        type: 'ERROR',
        platform,
        title: 'hockey-challenge-error',
        data: messageData,
      });
      if (err.code === 500) {
        return dispatch(apiActions('data_500').fetchFailure(err));
      }
      return dispatch(fetchFailure(err));
    },
  );
};

export const fetchLeaderboardData = (board, challengeNumber, season) => async (dispatch, getState) => {
  const { config } = getState();
  const { apiUrl, userId, env, currentSession, platform } = config;
  const { fetchStart } = apiActions('leaderboard');

  dispatch(fetchStart());

  // TODO: REMOVE WHEN BOOM GOES LIVE
  // const mockresponse = env === 'staging' ? getMockResponse(board) : undefined;

  return fetchContestRank({
    dispatch,
    apiUrl,
    userId,
    env,
    currentSession,
    board,
    challengeNumber,
    season,
    platform,
    // mockresponse,
  });
};

/**
 * Fetch Local rank status
 * @param {*} board : what leaderboard you are currently on (season/monthly/postSeason)
 * @param {*} challengeNumber : specific to monthly leaderboard specific challenge number
 * @returns array of users in order of their contest rank
 */
export const fetchLocalLeaderboardData = (board, isLocal, challengeNumber, season) => (dispatch, getState) => {
  const { config } = getState();
  const { apiUrl, userId, env, currentSession, platform } = config;
  const { fetchStart } = apiActions('local_leaderboard');

  dispatch(fetchStart());
  // TODO: REMOVE WHEN BOOM GOES LIVE
  // const mockresponse = env === 'staging' ? getMockResponse(board) : undefined;

  return fetchContestRank({
    dispatch,
    apiUrl,
    userId,
    env,
    currentSession,
    board,
    isLocal,
    challengeNumber,
    season,
    platform,
    // mockresponse,
  });
};

/**
 * Fetch season status, sets isCurrentlySeason boolean in store, used to determine whether season is live or not
 * @returns boolean status of season
 */
export const fetchIsCurrentlySeason = () => (dispatch, getState) => {
  const { config } = getState();
  const { apiUrl, userId, env, currentSession, platform } = config;
  const { fetchStart } = apiActions('season_status');
  const { fetchSuccess, fetchFailure } = apiActions('season_status');
  const { fetchFailure: authFailure } = apiActions('auth');

  dispatch(fetchStart());

  return makeRequest({
    method: 'GET',
    apiUrl,
    userId,
    env,
    currentSession,
    route: 'seasonLeaderboard',
    // TODO: REMOVE WHEN BOOM GOES LIVE
    // ...(env === 'staging' && { headers: { mockresponse: getMockResponse('season') } }),
  }).then(
    (resp) => {
      const status = resp.status === 'current';
      return dispatch(fetchSuccess(status));
    },
    (err) => {
      if (err.status === 401) {
        return dispatch(authFailure());
      }
      const messageData = {
        err,
        route: 'seasonLeaderboard',
        apiUrl,
        userId,
        currentSession,
      };
      fireMessageEvent({
        type: 'ERROR',
        platform,
        title: 'hockey-challenge-error',
        data: messageData,
      });
      if (err.code === 500) {
        // trigger game crash modal
        return dispatch(apiActions('data_500').fetchFailure(err));
      }
      return dispatch(fetchFailure(err));
    },
  );
};

/**
 * Fetch playoffs status, sets isCurrentlyPlayoffs boolean in store, used to determine whether playoffs are live or not
 * @returns boolean status of playoffs
 */
export const fetchIsCurrentlyPlayoffs = () => (dispatch, getState) => {
  const { config } = getState();
  const { apiUrl, userId, env, currentSession, platform } = config;
  const { fetchStart } = apiActions('playoffs_status');
  const { fetchSuccess, fetchFailure } = apiActions('playoffs_status');
  const { fetchFailure: authFailure } = apiActions('auth');

  dispatch(fetchStart());

  return makeRequest({
    method: 'GET',
    apiUrl,
    userId,
    env,
    currentSession,
    route: 'postSeasonLeaderboard',
    // TODO: REMOVE WHEN BOOM GOES LIVE
    // ...(env === 'staging' && { headers: { mockresponse: getMockResponse('playoffs') } }),
  }).then(
    (resp) => {
      const status = resp.status === 'current';
      return dispatch(fetchSuccess(status));
    },
    (err) => {
      if (err.status === 401) {
        return dispatch(authFailure());
      }
      const messageData = {
        err,
        route: 'postSeasonLeaderboard',
        apiUrl,
        userId,
        currentSession,
      };
      fireMessageEvent({
        type: 'ERROR',
        platform,
        title: 'hockey-challenge-error',
        data: messageData,
      });
      if (err.code === 500) {
        // trigger game crash modal
        return dispatch(apiActions('data_500').fetchFailure(err));
      }
      return dispatch(fetchFailure(err));
    },
  );
};

export const setChallengeNumber = (challengeNumber) => (dispatch) => {
  const { setValue } = commonActions('challenge_number');
  dispatch(setValue(challengeNumber));
};

export const setBoardView = (board) => (dispatch) => {
  const { setValue } = commonActions('board_view');
  dispatch(setValue(board));
};
